var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOnline = function SvgOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.999,
    cy: 47,
    r: 38.943,
    fill: "url(#online_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 44.5,
    stroke: "url(#online_svg__b)",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.001,
    cy: 47,
    r: 40.971,
    stroke: "url(#online_svg__c)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__d)",
    stroke: "url(#online_svg__e)",
    d: "M32.816 38.282a4.9 4.9 0 0 1 1.045-1.556q.677-.677 1.552-1.05a4.8 4.8 0 0 1 1.897-.383h2.383c.795 0 1.437-.646 1.437-1.44s-.642-1.44-1.437-1.44H37.31a7.723 7.723 0 0 0-5.483 2.277 7.8 7.8 0 0 0-1.66 2.47 7.7 7.7 0 0 0-.608 3.028v14.618a7.75 7.75 0 0 0 2.269 5.498l.353-.353-.354.353a7.707 7.707 0 0 0 5.483 2.277h4.249v2.806h-2.546c-.795 0-1.437.646-1.437 1.44s.642 1.44 1.437 1.44H55.52c.795 0 1.437-.646 1.437-1.44s-.642-1.44-1.437-1.44h-2.546V62.58h4.25a7.723 7.723 0 0 0 5.483-2.277 7.772 7.772 0 0 0 2.268-5.498V42.813a1.438 1.438 0 1 0-2.874 0v11.993l-.001.02H32.433V40.188c0-.663.13-1.304.383-1.906Zm26.303 21.035a4.8 4.8 0 0 1-1.897.384H37.31a4.84 4.84 0 0 1-3.928-1.995H61.15a4.859 4.859 0 0 1-2.03 1.611Zm-9.02 6.07h-5.666V62.58H50.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__f)",
    stroke: "url(#online_svg__g)",
    d: "M67.077 30.055v-.04h-9.895c-1.838 0-3.33 1.5-3.33 3.34v7.255h12.725c1.838 0 3.33-1.5 3.33-3.34v-3.913c0-1.67-1.229-3.06-2.83-3.302Zm-.044 7.216c0 .254-.207.459-.456.459h-9.851v-4.375c0-.255.206-.46.456-.46h9.395c.25 0 .456.205.456.46v3.916Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__h)",
    stroke: "url(#online_svg__i)",
    d: "M59.023 34.477a1.046 1.046 0 1 0 0 2.092 1.046 1.046 0 0 0 0-2.092Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__j)",
    stroke: "url(#online_svg__k)",
    d: "M61.756 34.477a1.046 1.046 0 1 0-.001 2.092 1.046 1.046 0 0 0 0-2.092Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__l)",
    stroke: "url(#online_svg__m)",
    d: "M64.488 34.477a1.046 1.046 0 1 0 0 2.092 1.046 1.046 0 0 0 0-2.092Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__n)",
    stroke: "url(#online_svg__o)",
    d: "M36.803 52.728c0 .794.641 1.44 1.437 1.44.795 0 1.437-.646 1.437-1.44 0-4.213 3.416-7.64 7.611-7.64s7.614 3.425 7.614 7.64a1.438 1.438 0 1 0 2.874 0c0-5.798-4.702-10.52-10.488-10.52s-10.485 4.72-10.485 10.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__p)",
    stroke: "url(#online_svg__q)",
    d: "M47.29 42.138c3.286 0 5.954-2.68 5.954-5.972s-2.668-5.973-5.954-5.973-5.954 2.68-5.954 5.973 2.668 5.972 5.954 5.972Zm0-9.064a3.09 3.09 0 0 1 3.08 3.092 3.09 3.09 0 0 1-3.08 3.091 3.09 3.09 0 0 1-3.08-3.091 3.09 3.09 0 0 1 3.08-3.092Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__r)",
    stroke: "url(#online_svg__s)",
    d: "M47.406 29.22c.795 0 1.437-.647 1.437-1.441v-3.886c0-.794-.642-1.44-1.437-1.44-.796 0-1.437.646-1.437 1.44v3.886c0 .794.641 1.44 1.437 1.44Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__t)",
    stroke: "url(#online_svg__u)",
    d: "M43.624 29.534v-.002a1.443 1.443 0 0 0-.337-2.007l-2.582-1.84v-.001a1.436 1.436 0 0 0-2.006.339 1.443 1.443 0 0 0 .338 2.008l.13.093h.003l2.45 1.747a1.438 1.438 0 0 0 2.003-.337Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#online_svg__v)",
    stroke: "url(#online_svg__w)",
    d: "M51.522 27.525a1.443 1.443 0 0 0-.339 2.007c.281.397.725.606 1.172.606h.003c.287 0 .58-.087.832-.267l2.581-1.84c.647-.462.797-1.36.338-2.008l-.408.29.408-.29a1.436 1.436 0 0 0-2.006-.339z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-174.644 24.649 23.466)scale(39.1136 41.1091)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-19.447 147.908 -103.465)scale(37.7829 48.1157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.47147 20.81422 -35.78153 -33.47322 70.5 42.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(13.04375 -4.66425 8.09764 22.64534 45.76 48.983)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-10.51513 6.96905 -19.59544 -29.56622 47.265 48.593)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.70624 -1.28402 1.5059 6.6923 61.22 34.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.60006 1.9185 -4.16176 -9.97883 61.879 34.832)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.41427 -.14627 .25145 .71217 58.975 35.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(146.799 24.225 26.532)scale(.39912 1.11661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.41427 -.14627 .25145 .71217 61.708 35.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(146.799 25.59 26.94)scale(.39912 1.11661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.41427 -.14627 .25145 .71217 64.44 35.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(146.799 26.957 27.347)scale(.39912 1.11661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-10.966 272 -217.898)scale(7.71092 7.88526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.10263 2.19155 -4.25669 -11.85325 47.289 47.639)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.1345 -1.46457 2.52416 7.1257 46.813 35.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.333 2.1883 -6.13025 -9.33703 47.29 35.617)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.71039 -.7716 2.10542 1.9384 47.324 25.612)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(116.415 15.785 27.466)scale(1.2873 3.13172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.68912 -.49797 .73962 2.50879 40.967 27.633)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(151.347 17.058 19.052)scale(1.55169 3.9868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.68912 -.49797 .73962 2.50879 53.451 27.633)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "online_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(151.347 23.3 20.646)scale(1.55169 3.9868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })))));
};
export default SvgOnline;